import type { TourConfig } from './types';

export const auditLogsTour: TourConfig = {
  id: 'audit-logs-page',
  name: 'Audit Logs Tour',
  description: 'Learn how to review audit logs',
  requiredPath: '/dashboard/settings/audit',
  steps: [
    {
      element: '[data-tour="audit-header"]',
      popover: {
        title: 'Audit Logs',
        description:
          'Track all actions performed in your organization for security and compliance.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="audit-action-filter"]',
      popover: {
        title: 'Filter by Action',
        description:
          'Type an action name to filter logs, such as "users.invite" or "roles.create".',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="audit-method-filter"]',
      popover: {
        title: 'Filter by HTTP Method',
        description: 'Filter logs by HTTP method: POST, PUT, PATCH, or DELETE.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="audit-table"]',
      popover: {
        title: 'Audit Log Table',
        description:
          'View all audit entries here. Click on a row to see full details including metadata and IP address.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
